import { Box, Divider, styled } from '@/shared/ui';
import { CustomTypography } from '@/shared/ui/Typography';

export const TariffCardContainer = styled(Box)(({ theme }) => ({
  padding: '16px 18px',
}));

export const Header = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const TariffName = styled(CustomTypography)(({ theme }) => ({
  fontSize: '13px',
  textTransform: 'uppercase',
  backgroundColor: theme.palette.primary.main,
  borderRadius: '5px',
  ml: '5px',
  padding: '5px',
  color: theme.palette.secondary.contrastText,
}));

export const PriceBlock = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  margin: '8px 0',
});

export const Price = styled(CustomTypography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  color: selected ? theme.palette.common.white : theme.palette.custom.black[50],
  fontSize: '18px',
}));

export const OldPrice = styled(CustomTypography, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  textDecoration: 'line-through',
  color: selected ? theme.palette.common.white : theme.palette.custom.black[30],
  fontSize: '18px',
}));

export const StylesDivider = styled(Divider)(({ theme }) => ({
  border: `1px solid ${theme.palette.custom.black[10]}`,
  margin: '11px 0',
}));

export const Features = styled('ul')({
  listStyle: 'none',
  padding: 0,
  margin: 0,
});

export const FeatureRow = styled('li')({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '26px',
  fontSize: '14px',
  paddingBottom: '5px',
});
